module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/InviteMessage.ejs -->\nInvitation email to employee will be sent shortly\n<strong class="modal-message">Note: token will expire after 48 hours</strong>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/InviteMessage.ejs
// module id = 778
// module chunks = 1